import { Component } from '@angular/core';
import { TableComponent } from '@shared/components/table/table.component';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import {
  dashboardCompleteModal,
  dashboardReplyModal,
  serviceRequestRemoveModal
} from '@views/dashboard/list-views/util/dashboard-modals.util';
import {
  DashboardServicerequestBaseComponent,
  ServiceRequestConfig
} from '@shared/modals/dashboard/query/service-request-base/service-request-base.component';
import { HeaderService } from '@app/core/services/header.service';
import { ODataService } from '@app/core/services/odata/odata.service';
import { ModalService } from '@app/core/services/modal.service';
import { createActions } from '@app/core/utils/service-request.helper';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ToggleComponent } from '@shared/components/input/toggle/toggle.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { SortDir } from '@app/core/constants/sort-dir';

@Component({
  imports: [
    TableComponent,
    ToggleComponent,
    TranslatePipe,
    ReactiveFormsModule
  ],
  templateUrl: './dashboard-servicerequest-reopen.component.html',
})
export class DashboardServicerequestReopenComponent extends DashboardServicerequestBaseComponent {
  protected config: ServiceRequestConfig = {
    tableId: 'table-dashboard-query-reopen',
    titleKey: 'dashboard.query.reopen.title',
    odataType: ODataType.connected,
    fixedSort: { sortField: 'isCancelledBySupplier', sortDirection: SortDir.desc },
    defaultSort: { sortField: 'occurrence', sortDirection: SortDir.asc },
  };

  public form: FormGroup = new FormGroup({
    processedRequests: new FormControl(false)
  });

  constructor(
    headerService: HeaderService,
    oDataService: ODataService,
    modalService: ModalService,
    private readonly route: ActivatedRoute
  ) {
    super(headerService, oDataService, modalService);

    this.route.queryParams.subscribe(qp => {
      const processed = qp['processedRequests'] === 'true';
      this.form.get('processedRequests')!.setValue(processed, {
        emitEvent: false
      });
      this.config.customParams = {
        processedRequests: this.form.get('processedRequests')!.value.toString()
      };
    });

    // Subscribe to toggle changes
    this.form.get('processedRequests')!.valueChanges.subscribe(() => {
      this.config.customParams = {
        processedRequests: this.form.get('processedRequests')!.value.toString()
      };
      this.table?.search();
    });

    this.initialize();
  }

  protected getActions() {
    return createActions(
      {
        getSelectedElements: () => this.selectedElements,
        openReplyModal: () => this.openReplyModal(),
        openCompleteModal: () => this.openCompleteModal(),
        openRemoveModal: () => this.openRemoveModal(),
      },
      ['reply', 'complete', 'remove', 'list']
    );
  }

  public openCompleteModal(): void {
    this.modalService.show({
      ...dashboardCompleteModal,
      params: { actionType: 'reconnect', element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }

  public openReplyModal(): void {
    this.modalService.show({
      ...dashboardReplyModal,
      params: { actionType: 'reconnect', element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }

  public openRemoveModal(): void {
    this.modalService.show({
      ...serviceRequestRemoveModal,
      params: { element: this.selectedElements[0] }
    }).subscribe(() => this.refreshTable());
  }
}
